import { QuoteRoutes } from '../../../main/constants'
import { StatsQuery } from '../../stats/types'
import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-options-chain-link a')

export default function OptionsChainLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  if (!currentTimeframePath)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Options Chain
      </a>
    )

  const newURL = new URL(currentTimeframePath, window.location.origin)
  newURL.searchParams.set(StatsQuery.ChartType, QuoteRoutes.OptionsChain)

  return (
    <a href={`${newURL.pathname}${newURL.search}`} className="tab-link">
      Options Chain
    </a>
  )
}
